import { type MantineBreakpoint, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { type ReactNode, useMemo } from 'react';

type VisibleBetweenProps = {
  from?: MantineBreakpoint; // optional
  to?: MantineBreakpoint; // optional
  excludeFrom?: boolean; // default: false
  excludeTo?: boolean; // default: false
  children: ReactNode;
};

export const VisibleBetween = ({ from, to, excludeFrom = false, excludeTo = false, children }: VisibleBetweenProps) => {
  const theme = useMantineTheme();
  const breakpoints = theme.breakpoints;

  const minWidth = from ? breakpoints[from] : undefined;
  const maxWidth = to ? breakpoints[to] : undefined;

  const query = useMemo(() => {
    const parts: string[] = [];

    if (minWidth) {
      parts.push(`(min-width: ${excludeFrom ? `calc(${minWidth} + 0.1px)` : minWidth})`);
    }

    if (maxWidth) {
      parts.push(`(max-width: ${excludeTo ? `calc(${maxWidth} - 0.1px)` : maxWidth})`);
    }

    return parts.join(' and ');
  }, [minWidth, maxWidth, excludeFrom, excludeTo]);

  const isVisible = useMediaQuery(query);

  if ((from && !minWidth) || (to && !maxWidth)) {
    console.warn(`Breakpoint "${from}" or "${to}" not found in theme.breakpoints`);
    return null;
  }

  return isVisible ? <>{children}</> : null;
};
